module.exports = __webpack_public_path__ + "img/lang-de.88553ec1.svg";